import { useState } from "react";
import useMerchantPortalAxios, {
  useMerchantPortalFormData,
} from "../utils/axios";
import {
  setFlag,
  setIsPopup,
  setLoading,
  setResponseDescription,
  setResponseInfo,
  setResponseTitle,
} from "../features/responseSlice";
import { useDispatch } from "react-redux";
import CryptoJS from "crypto-js";
import { certificate, config } from "../utils/Constants";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { faLongArrowAltDown } from "@fortawesome/free-solid-svg-icons";
import { setPayrollsOverviewMobile } from "../features/appMobileSlice";
import {
  appendEmployeeOverviewData,
  setEmployeeOverviewData,
} from "../features/employeesSlice";

function PayrollApi() {
  const [payrollTemplate, setPayrollTemplate] = useState([]);
  const [payrolls, setPayrolls] = useState(null);
  const [payrollsLoading, setPayrollsLoading] = useState(true);
  const [payrollsOverview, setPayrollsOverview] = useState([]);
  const [payrollsOverviewLoading, setPayrollsOverviewLoading] = useState(true);
  const [payrollsExportLoading, setPayrollsExportLoading] = useState(false);
  const [quickPayPopup, setQuickPayPopup] = useState({});

  const MerchantPortalAxios = useMerchantPortalAxios();
  const MerchantPortalAxios1 = useMerchantPortalFormData();
  const CustomMerchantPortalClient = MerchantPortalAxios;
  CustomMerchantPortalClient.defaults.timeout = 600000;
  const CustomMerchantPortalClient1 = MerchantPortalAxios1;
  CustomMerchantPortalClient1.defaults.timeout = 600000;

  const URL = config.url;

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleResponse = (res) => {
    if ([0, 1].includes(res?.flagCode)) {
      dispatch(setIsPopup(true));
      dispatch(setFlag(res?.flagCode || 0));
      dispatch(setResponseTitle(res.Title));
      dispatch(setResponseDescription(res.Message));
    } else {
      if (res?.flagCode === 2) {
        dispatch(setLoading("idle"));
        dispatch(setIsPopup(true));
        dispatch(setFlag(res?.flagCode || 10));
        dispatch(setResponseTitle(res.Title));
        dispatch(setResponseDescription(res.Message));
      }
    }
  };

  const GetPayrollTemplate = async () => {
    const res = await MerchantPortalAxios.get("/v1/Payroll/GetPayrollTemplate");
    if (res) {
      setPayrollTemplate(res.data);
    }
  };

  const DownloadPayrollOverview = async (refID) => {
    const res = await MerchantPortalAxios.post(
      "/v1/Payroll/ExportPayrollData",
      {
        SessionID: sessionStorage.getItem("SessionID"),
        Reference: refID,
      },
    );

    return res.data.Payload;
  };

  const DownloadPayrollOverviewMobile = async (refID) => {
    const res = await axios.post(
      `${URL}/v1/Payroll/ExportPayrollData`,
      {
        SessionID: sessionStorage.getItem("SessionMobile"),
        Reference: refID,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: sessionStorage.getItem("TokenMobile"),
        },
      },
    );

    return res.data.Payload;
  };

  const SubmitPayrollTemplate = async (payload) => {
    if (payload.formFile) {
      const fileData = payload.formFile.split(",")[1];
      const mimeType = payload.formFile.split(":")[1].split(";")[0];
      const byteCharacters = atob(fileData);
      const byteArrays = new Uint8Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteArrays[i] = byteCharacters.charCodeAt(i);
      }
      payload.formFile = new File([byteArrays], payload.ReasonFileName, {
        type: mimeType,
      });
    }

    const { ReasonFileName, ...newPayload } = payload;

    const response = await CustomMerchantPortalClient1.post(
      "/v1/Payroll/SubmitPayrollTemplate",
      newPayload,
    );
    return response.data.Payload;
  };

  const ConfirmPayrollTemplate = async (payload) => {
    const newPayrollInfos = payload.payrollInfos.map((item) => {
      const { id, ...sanitizedItem } = item;
      return {
        ...sanitizedItem,
        Amount: sanitizedItem.Amount.toString(),
      };
    });

    const jsonString = JSON.stringify(newPayrollInfos) + certificate;
    const encryptedData = CryptoJS.SHA512(jsonString).toString();

    const newPayload = {
      ...payload,
      Hash: encryptedData,
      PayrollType: payload.PayrollType,
    };

    const response = await CustomMerchantPortalClient.post(
      "/v1/Payroll/ConfirmPayrollTemplate",
      newPayload,
    );
    return response.data.Payload;
  };

  const GetPayrollOverview = async (
    lastId,
    input,
    currency,
    status,
    payrollId,
    isExport = false,
  ) => {
    setPayrollsLoading(true);
    if (isExport) {
      setPayrollsOverviewLoading(true);
    }
    return MerchantPortalAxios.post("/v1/Payroll/GetPayrollOverview", {
      SessionID: sessionStorage.getItem("SessionID"),
      LastID: lastId,
      SearchInput: input,
      Currency: currency,
      Status: status,
      PayrollReferenceNumber: payrollId,
      IsExport: isExport,
    })
      .then((res) => {
        if (lastId !== 0) {
          setPayrolls([...payrolls, ...res.data.Payload.PayrollSOAs]);
        } else {
          setPayrolls(res.data.Payload.PayrollSOAs);
        }
        return res.data?.Payload?.PayrollSOAs || [];
      })
      .finally(() => {
        setPayrollsLoading(false);
        setPayrollsExportLoading(false);
      });
  };

  const GetPayrollOverviewMobile = async (
    lastId,
    input,
    currency,
    status,
    payrollId,
    isExport = false,
  ) => {
    setPayrollsLoading(true);
    if (isExport) {
      setPayrollsOverviewLoading(true);
    }
    return axios
      .post(
        `${URL}/v1/Payroll/GetPayrollOverview`,
        {
          SessionID: sessionStorage.getItem("SessionMobile"),
          LastID: lastId,
          SearchInput: input,
          Currency: currency,
          Status: status,
          PayrollReferenceNumber: payrollId,
          IsExport: isExport,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: sessionStorage.getItem("TokenMobile"),
          },
        },
      )
      .then((res) => {
        if (lastId !== 0) {
          setPayrolls([...payrolls, ...res.data.Payload.PayrollSOAs]);
        } else {
          setPayrolls(res.data.Payload.PayrollSOAs);
        }
        return res.data?.Payload?.PayrollSOAs || [];
      })
      .finally(() => {
        setPayrollsLoading(false);
        setPayrollsExportLoading(false);
      });
  };

  const RemindPayrollNonSuyooler = async (tranId, recepient, mobileNo) => {
    const response = await MerchantPortalAxios.post(
      "/v1/Payroll/RemindPayrollNonSuyooler",
      {
        SessionID: sessionStorage.getItem("SessionID"),
        TransactionID: tranId,
        Recepient: recepient,
        MobileNo: mobileNo,
      },
    ).then((res) => {
      handleResponse(res.data.Payload);
    });
    return response.data;
  };

  const PaySinglePayroll = async (payload) => {
    const response = await MerchantPortalAxios.post(
      "/v1/Payroll/PaySinglePayroll",
      payload,
    );
    return response.data.Payload;
  };

  const PaySinglePayrollMobile = async (payload) => {
    const response = await axios.post(
      `${URL}/v1/Payroll/PaySinglePayroll`,
      payload,
      {
        headers: {
          Content_Type: "application/json",
          Authorization: sessionStorage.getItem("TokenMobile"),
        },
      },
    );
    return response.data.Payload;
  };

  const DeletePayroll = async (payload) => {
    const response = await MerchantPortalAxios.post(
      "/v1/Payroll/DeletePayroll",
      payload,
    );
    return response.data.Payload;
  };

  const DeletePayrollMobile = async (payload) => {
    const response = await axios.post(
      `${URL}/v1/Payroll/DeletePayroll`,
      payload,
      {
        headers: {
          Content_Type: "application/json",
          Authorization: sessionStorage.getItem("TokenMobile"),
        },
      },
    );
    return response.data.Payload;
  };

  const CommunicatePayroll = async (reference, payrollIds) => {
    const response = await MerchantPortalAxios.post(
      "/v1/Payroll/CommunicatePayroll",
      {
        SessionID: sessionStorage.getItem("SessionID"),
        Reference: reference,
        PayrollIds: payrollIds,
      },
    );
    return response.data.Payload;
  };

  const GetPayrollSummaryByReferenceNo = async (reference) => {
    const response = await MerchantPortalAxios.post(
      "/v1/Payroll/GetPayrollSummaryByReferenceNo",
      {
        SessionID: sessionStorage.getItem("SessionID"),
        ReferenceNo: reference,
      },
    ).then((res) => {
      navigate("/pendingapprovals/pendingsummary");
      dispatch(
        setResponseInfo({
          payrollCheck: true,
          payrollSummary: res.data.Payload,
          referenceNo: reference,
        }),
      );
    });
  };

  const GetPayrollSummaryByReferenceNoMobile = async (reference) => {
    const data = {
      SessionID: sessionStorage.getItem("SessionMobile"),
      ReferenceNo: reference,
    };

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: sessionStorage.getItem("TokenMobile"),
      },
    };

    try {
      const res = await axios.post(
        `${URL}/v1/Payroll/GetPayrollSummaryByReferenceNo`,
        data,
        config,
      );
      // navigate('/pendingapprovals/pendingsummary');
      dispatch(
        setResponseInfo({
          payrollCheck: true,
          payrollSummary: res.data.Payload,
          referenceNo: reference,
        }),
      );
    } catch (error) {
      console.error("Error in GetPayrollSummaryByReferenceNoMobile:", error);
    }
  };

  const RejectPayroll = async (payload) => {
    const response = await MerchantPortalAxios.post(
      "/v1/Payroll/RejectPayroll",
      payload,
    );
    return response.data.Payload;
  };

  const RejectPayrollMobile = async (payload) => {
    const response = await MerchantPortalAxios.post(
      `${URL}/v1/Payroll/RejectPayroll`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: sessionStorage.getItem("TokenMobile"),
        },
      },
    );
    return response.data.Payload;
  };

  const ApprovePayroll = async (payload) => {
    const response = await MerchantPortalAxios.post(
      "/v1/Payroll/ApprovePayroll",
      payload,
    );

    return response.data.Payload;
  };

  const ApprovePayrollMobile = async (payload) => {
    const response = await axios.post(
      `${URL}/v1/Payroll/ApprovePayroll`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: sessionStorage.getItem("TokenMobile"),
        },
      },
    );
    return response.data.Payload;
  };

  const GetPayrollSubmitted = async (searchInput, currency, status) => {
    await MerchantPortalAxios.post("/v1/Payroll/GetPayrollSubmitted", {
      SessionID: sessionStorage.getItem("SessionID"),
      SearchInput: searchInput,
      Currency: currency,
      Status: status,
    })
      .then((res) => {
        setPayrollsOverview(res.data.Payload.payrolls);
      })
      .finally(() => {
        setPayrollsOverviewLoading(false);
      });
  };

  const GetPayrollSubmittedMobile = async (searchInput, currency, status) => {
    setPayrollsOverviewLoading(true);
    try {
      const response = await axios.post(
        `${URL}/v1/Payroll/GetPayrollSubmitted`,
        // Request body:
        {
          SessionID: sessionStorage.getItem("SessionMobile"),
          SearchInput: searchInput,
          Currency: currency,
          Status: status,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: sessionStorage.getItem("TokenMobile"),
          },
        },
      );
      dispatch(setPayrollsOverviewMobile(response.data.Payload.payrolls));
    } catch (error) {
      console.error("Error fetching payrolls:", error);
    } finally {
      setPayrollsOverviewLoading(false);
    }
  };

  const ExportPayrollReceipts = async (payload) => {
    const response = await MerchantPortalAxios.post(
      "/v1/Payroll/ExportPayrollReceipts",
      payload,
    );
    return response?.data?.Payload;
  };

  const CancelPayrollTemplate = async (payload) => {
    const response = await MerchantPortalAxios.post(
      "/v1/Payroll/CancelPayrollTemplate",
      payload,
    );
    return response?.data?.Payload;
  };

  const CheckQuickPayPopup = async () => {
    try {
      const response = await MerchantPortalAxios.post(
        "/v1/Payroll/CheckQuickPayPopup",
        {
          SessionID: sessionStorage.getItem("SessionID"),
          PayrollType: 1,
        },
      );

      setQuickPayPopup(response.data.Payload);
      const payload = response.data.Payload;

      return payload;
    } catch (error) {
      console.error(error);
    }
  };

  const GetEmployeeOverview = async (
    lastPayrollId,
    dateeFrom,
    dateTo,
    searchInput,
    currency,
    status,
  ) => {
    setPayrollsLoading(true);
    try {
      const response = await MerchantPortalAxios.post(
        "/v1/Payroll/GetEmployeesOverview",
        {
          SessionID: sessionStorage.getItem("SessionID"),
          LastPayrollId: lastPayrollId,
          DateFrom: dateeFrom,
          DateTo: dateTo,
          SearchInput: searchInput,
          Currency: currency,
          Status: status,
        },
      );

      const loadMoreData = response.data.Payload.PayrollEmployeesOverviews;

      if (lastPayrollId === 0) {
        dispatch(setEmployeeOverviewData(loadMoreData));
      } else {
        dispatch(appendEmployeeOverviewData(loadMoreData));
      }

      return loadMoreData;
    } catch (error) {
      console.error(error);
    } finally {
      setPayrollsLoading(false);
    }
  };

  const ActionEmployeesOverview = async (payload) => {
    const response = await MerchantPortalAxios.post(
      "/v1/Payroll/ActionEmployeesOverview",
      payload,
    );

    return response.data.Payload;
  };

  const ValidatePayrollTemplate = async (TypeId) => {
    const response = await MerchantPortalAxios.post(
      "/v1/Payroll/ValidatePayrollTemplate",
      {
        SessionID: sessionStorage.getItem("SessionID"),
        PayrollTypeId: TypeId,
      },
    );

    return response.data.Payload;
  };

  return {
    GetPayrollTemplate,
    payrollTemplate,
    SubmitPayrollTemplate,
    ConfirmPayrollTemplate,
    GetPayrollOverview,
    GetPayrollOverviewMobile,
    payrolls,
    payrollsLoading,
    RemindPayrollNonSuyooler,
    PaySinglePayroll,
    DeletePayroll,
    DeletePayrollMobile,
    PaySinglePayrollMobile,
    CommunicatePayroll,
    GetPayrollSummaryByReferenceNo,
    GetPayrollSummaryByReferenceNoMobile,
    RejectPayroll,
    RejectPayrollMobile,
    ApprovePayroll,
    ApprovePayrollMobile,
    GetPayrollSubmitted,
    payrollsOverview,
    payrollsOverviewLoading,
    payrollsExportLoading,
    ExportPayrollReceipts,
    DownloadPayrollOverview,
    DownloadPayrollOverviewMobile,
    GetPayrollSubmittedMobile,
    CancelPayrollTemplate,
    CheckQuickPayPopup,
    quickPayPopup,
    GetEmployeeOverview,
    ActionEmployeesOverview,
    ValidatePayrollTemplate,
  };
}

export default PayrollApi;
